function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useCssInJs } from "../../../../hooks";
import { Button, DatePicker, Dropdown } from 'antd';
import cx from 'classnames';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useTaskList } from "../../TaskListStore";
import { FILTER2_MAP } from "../../constants";
import { getFilterItemRangePickerFooterStyle, getTaskListLeftFilterHeaderStyle } from "./styles";
import { ReactComponent as IconArrowDown } from "../../../../assets/svg/icon-arrow-down.svg";
import { ALL_START_TIME } from "../../constants";
import "../../customAntdStyles/custom-antdesign-styles.css";
import { Tabs } from "../Tabs";
import TaskClassifyMenuItem from "./TaskClassifyMenuItem";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

// 预设枚举
var PresetEnum = /*#__PURE__*/function (PresetEnum) {
  PresetEnum[PresetEnum["UNKNOWN"] = 0] = "UNKNOWN";
  PresetEnum[PresetEnum["ALL"] = 1] = "ALL";
  PresetEnum[PresetEnum["TODAY"] = 2] = "TODAY";
  PresetEnum[PresetEnum["THIS_WEEK"] = 3] = "THIS_WEEK";
  PresetEnum[PresetEnum["LAST_MONTH"] = 4] = "LAST_MONTH";
  return PresetEnum;
}(PresetEnum || {});
export default function LeftFilterHeader() {
  var prefix = 'tasklist-left-filter-header';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: getTaskListLeftFilterHeaderStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var leftFilterHeaderRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSelectedClassify = _useState2[0],
    setIsSelectedClassify = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSelectedDate = _useState4[0],
    setIsSelectedDate = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    rangePickerValue = _useState6[0],
    setRangePickerValue = _useState6[1];
  var _useTaskList = useTaskList(),
    _useTaskList2 = _slicedToArray(_useTaskList, 2),
    snap = _useTaskList2[0],
    state = _useTaskList2[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    open = _useState8[0],
    setOpen = _useState8[1];

  // 当前选中的预设
  var _useState9 = useState(PresetEnum.ALL),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedPreset = _useState10[0],
    setSelectedPreset = _useState10[1];
  var segmentedOptions = Object.values(FILTER2_MAP).map(function (item) {
    return {
      label: item.text,
      value: item.value
    };
  });
  useEffect(function () {
    if (state.classifyCode) {
      setIsSelectedClassify(true);
    } else {
      setIsSelectedClassify(false);
    }
    if (state.startTime && state.startTime !== ALL_START_TIME && state.endTime) {
      setIsSelectedDate(true);
    } else {
      // 相当于“全部”
      setIsSelectedDate(false);
      setRangePickerValue(null);
    }
  }, [state.classifyCode, state.startTime, state.endTime]);
  var rangePresets = [{
    label: /*#__PURE__*/_jsx("span", {
      className: "dataPickerPreset".concat(selectedPreset === PresetEnum.ALL ? ' presetSelected' : ''),
      children: "\u5168\u90E8"
    }),
    value: [dayjs('2000/01/01'), dayjs()]
  }, {
    label: /*#__PURE__*/_jsx("span", {
      className: "dataPickerPreset".concat(selectedPreset === PresetEnum.TODAY ? ' presetSelected' : ''),
      children: "\u5F53\u5929"
    }),
    value: [dayjs(), dayjs()]
  }, {
    label: /*#__PURE__*/_jsx("span", {
      className: "dataPickerPreset".concat(selectedPreset === PresetEnum.THIS_WEEK ? ' presetSelected' : ''),
      children: "\u672C\u5468"
    }),
    value: [dayjs().startOf('week'), dayjs()]
  }, {
    label: /*#__PURE__*/_jsx("span", {
      className: "dataPickerPreset".concat(selectedPreset === PresetEnum.LAST_MONTH ? ' presetSelected' : ''),
      children: "\u4E0A\u6708"
    }),
    value: [dayjs().add(-1, 'month').startOf('month'), dayjs().add(-1, 'month').endOf('month')]
  }];
  var onRangeChange = function onRangeChange(dates, dateStrings) {
    if (dates) {
      // console.log('From: ', dates[0], ', to: ', dates[1])
      // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1])
      var start = dayjs(dateStrings[0]).startOf('day');
      var end = dayjs(dateStrings[1]).endOf('day');
      var fmt = 'YYYY-MM-DD HH:mm:ss';
      state.startTime = start.format(fmt);
      state.endTime = end.format(fmt);
      setRangePickerValue([start, end]);
      // 根据日期范围计算预设
      if (dateStrings[0] === dateStrings[1]) {
        // 当天
        setSelectedPreset(PresetEnum.TODAY);
      } else if (start.isSame(dayjs(), 'week')) {
        // 当周
        setSelectedPreset(PresetEnum.THIS_WEEK);
      }
      // 上月
      else if (start.isSame(dayjs().add(-1, 'month'), 'month')) {
        // 上月
        setSelectedPreset(PresetEnum.LAST_MONTH);
      } else {
        setSelectedPreset(PresetEnum.UNKNOWN);
      }
      // 全部日期
      if (dateStrings[0] === ALL_START_TIME) {
        state.startTime = undefined;
        state.endTime = undefined;
        setRangePickerValue(null);
        setSelectedPreset(PresetEnum.ALL);
      }
    } else {
      console.log('Clear');
    }
  };
  var handleDateSelection = function handleDateSelection(ev) {
    ev.preventDefault();
    setOpen(true);
  };
  var onClear = function onClear() {
    state.startTime = undefined;
    state.endTime = undefined;
    setRangePickerValue(null);
    setOpen(false);
  };
  return wrapSSR( /*#__PURE__*/_jsxs("div", {
    className: cx(prefix, hashId),
    ref: leftFilterHeaderRef,
    children: [/*#__PURE__*/_jsx(Tabs, {
      options: segmentedOptions,
      value: state.todoTimeType,
      onChange: function onChange(value) {
        // console.log(value) // string
        //@ts-ignore
        state.todoTimeType = value;
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: "filter-control",
      children: [/*#__PURE__*/_jsx(Dropdown, {
        className: "classification",
        dropdownRender: function dropdownRender(menu) {
          return /*#__PURE__*/_jsx(TaskClassifyMenuItem, {});
        },
        placement: "bottomLeft",
        arrow: true,
        getPopupContainer: function getPopupContainer() {
          return leftFilterHeaderRef.current;
        },
        children: /*#__PURE__*/_jsx("div", {
          className: cx('filter-item'),
          children: /*#__PURE__*/_jsxs("div", {
            className: cx('filter-item', 'padding', isSelectedClassify ? 'selected' : ''),
            onClick: function onClick(e) {
              return e.preventDefault();
            },
            children: [/*#__PURE__*/_jsx("span", {
              children: "\u5206\u7C7B"
            }), /*#__PURE__*/_jsx(IconArrowDown, {})]
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: cx('filter-item'),
        children: [/*#__PURE__*/_jsxs("a", {
          className: cx('filter-item', 'padding', isSelectedDate ? 'selected' : ''),
          onClick: handleDateSelection,
          children: [/*#__PURE__*/_jsx("span", {
            children: "\u65E5\u671F"
          }), /*#__PURE__*/_jsx(IconArrowDown, {})]
        }), /*#__PURE__*/_jsx(RangePicker, {
          presets: rangePresets,
          onChange: onRangeChange,
          onOpenChange: setOpen,
          autoFocus: true,
          open: open,
          value: rangePickerValue,
          className: cx('filter-item', 'range-picker'),
          renderExtraFooter: function renderExtraFooter() {
            return /*#__PURE__*/_jsx(RangePickerExtraFooter, {
              onClear: onClear
            });
          },
          getPopupContainer: function getPopupContainer() {
            return leftFilterHeaderRef.current;
          }
        })]
      })]
    })]
  }));
}
function RangePickerExtraFooter(props) {
  var prefix = 'filter-item-range-picker-footer';
  var _useCssInJs2 = useCssInJs({
      prefix: prefix,
      styleFun: getFilterItemRangePickerFooterStyle
    }),
    wrapSSR = _useCssInJs2.wrapSSR,
    hashId = _useCssInJs2.hashId;
  var handlerClear = function handlerClear() {
    props.onClear && props.onClear();
  };
  return wrapSSR( /*#__PURE__*/_jsx("div", {
    className: cx(prefix, hashId),
    children: /*#__PURE__*/_jsx(Button, {
      size: 'small',
      onClick: handlerClear,
      children: "\u6E05\u7A7A"
    })
  }));
}